
export const createCustomerStyles = {
  loadingContainer: (isInitialLoad) => ({
    position: isInitialLoad ? "relative" : "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: isInitialLoad ? "transparent" : "rgba(0, 0, 0, 0.3)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9998,
    minHeight: isInitialLoad ? "100vh" : "auto",
  }),
  mainContainer: {
    padding: "0px 32px 32px 32px",
  },
  breadcrumbContainer: {
    padding: "16px 8px",
  },
  breadcrumbButton: {
    color: "#1A6BE8",
    textDecoration: "none",
  },
  breadcrumbItem: {
    margin: 0,
  },
  formContainer: {
    padding: "16px",
    margin: "0px",
  },
  formRow: {
    padding: "0px",
  },
};


export const sharedGroupsCSS = `
  /* Shared Groups component styles */
  .add-group-form {
    padding: 20px 0px;
    border: 1px solid #ccc;
    border-radius: 8px;
    margin: 10px;
    font-family: "InframarkFont", Arial, Helvetica, sans-serif !important;
  }
  .row-padding-group {
    margin: 0 !important;
    padding: 0px 0px 16px 0px !important;
  }
  .btn-add-row {
    border-radius: var(--borderRadius, 4px);
    background: var(--primary-main, #1a6be8);
    padding: 6px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: var(--primary-contrastText, #fff);
    font-family: var(--fontFamily, Inter);
    font-size: var(--font-size-0875-rem, 14px);
    font-style: normal;
    font-weight: var(--fontWeightMedium, 500);
    line-height: 24px;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    border-color: #1a6be8;
  }
  .row-padding {
    margin: 0 !important;
    padding: 0px 0px 16px 0px !important;
  }
  .add-cust-form {
    padding: 16px;
    border: 1px solid #ccc;
    border-radius: 16px;
    font-family: "InframarkFont", Arial, Helvetica, sans-serif !important;
    border-radius: var(--Values-Shape-Radius-Extra-Large, 16px);
    background: var(--Colors-MUI-Schemes-background-Page-Background, #fafafa);
    box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.12), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 3px 3px -2px rgba(0, 0, 0, 0.2);
  }
  .title-font-style {
    color: var(--Neutral-07, #1a1d1f);
    font-feature-settings: "liga" off, "clig" off;
    font-family: var(--Font-fontFamily, Inter);
    font-size: var(--rem-font-size-125-rem, 24px);
    font-style: normal;
    font-weight: var(--Font-fontWeightMedium, 500);
    line-height: 160%;
    letter-spacing: 0.15px;
    margin-bottom: 0;
  }
  .breadcrumb-title-font-style {
    color: var(--Neutral-07, #1a6be8);
    font-feature-settings: "liga" off, "clig" off;
    font-family: var(--Font-fontFamily, Inter);
    font-size: var(--rem-font-size-125-rem, 16px);
    font-style: normal;
    font-weight: 400;
    line-height: "24px";
    letter-spacing: 0.15px;
    margin-bottom: 0;
  }
  .txt-right {
    text-align: end;
  }
  .disable-btn-create {
    background-color: #ebebe4 !important;
    color: #3333;
    cursor: not-allowed;
  }
  .textbox-style-change {
    border: none !important;
    outline: none !important;
    border-bottom: 2px solid lightgray !important;
    background: none !important;
    transition: border-color 0.3s;
    border-radius: 0px !important;
  }
  .textbox-style-change:active {
    border-bottom: 2px solid #22c55e;
  }
  .textbox-style-change-placeholder::placeholder {
    color: lightgray !important;
    font-size: 16px;
  }
  .preview-icon-bg {
    background: none !important;
    border: none !important;
    border-bottom: 2px solid lightgray !important;
    border-radius: 0 !important;
  }
  .preview-icon-bg:focus {
    border-bottom: 2px solid #86b7fe !important;
  }
  .form-control:focus {
    box-shadow: none !important;
  }
  .css-13cymwt-control {
    border: none;
    border-radius: 0% !important;
    border-style: none !important;
    background-color: unset !important;
  }
  .css-t3ipsp-control {
    box-shadow: white !important;
  }
  .css-t3ipsp-control:hover {
    border-color: white !important;
    outline: 0;
    box-shadow: none !important;
  }
  .css-t3ipsp-control:active {
    border-color: white !important;
    outline: none !important;
    box-shadow: none !important;
  }
  .txt-color-code {
    color: var(--text-secondary, rgba(0, 0, 0, 0.6));
  }
  .label-create-user {
    color: var(--text-secondary, rgba(0, 0, 0, 0.6));
    font-feature-settings: "liga" off, "clig" off;
    font-family: var(--Font-fontFamily, Inter);
    font-size: var(--rem_fontSize-1rem, 16px);
    font-style: normal;
    font-weight: var(--Font-fontWeightRegular, 400);
    line-height: 24px;
    letter-spacing: 0.15px;
  }
  .css-1u9des2-indicatorSeparator {
    -webkit-align-self: stretch;
    -ms-flex-item-align: stretch;
    align-self: stretch;
    width: 1px;
    background-color: none !important;
    margin-bottom: 8px;
    margin-top: 8px;
    box-sizing: border-box;
  }
  .form-group__label {
    font-size: 22px;
    font-weight: 600;
    line-height: 22.41px;
  }
  .form-group__label,
  .form-group__details {
    margin-bottom: 16px;
  }
  .form-group__details {
    font-size: 16px;
    font-weight: 600;
    line-height: 22.41px;
  }
  .error-border {
    border-color: red !important;
  }
`;

